import { render, staticRenderFns } from "./ReinstalacionServicios.vue?vue&type=template&id=aff272d6&"
import script from "./ReinstalacionServicios.vue?vue&type=script&lang=js&"
export * from "./ReinstalacionServicios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports